import React, { useEffect, useState } from 'react'
import { DocumentChartBarIcon, HomeIcon } from "@heroicons/react/16/solid";
import { Breadcrumb, Button } from "antd";
import { PlusOutlined } from '@ant-design/icons';
import ProfileTaskCard from './taskCard';
import { getRequest } from '../../utils/APICall';
import { TaskCardSkeleton } from './taskCardLoader';
import TaskModal from '../Task/taskModal';

const TaskOverview = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [taskOverview, setTaskOverview] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [projects, setProjects] = useState([]);
  const [tableReFetchData, setTableReFetchData] = useState(0);
  // console.log(taskOverview)
  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedTask(null);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    setSelectedTask(null);
  };
  const getAllProjects = async () => {
    const res = await getRequest("getAllProjects");
    // console.log(res)
    if (res.success) {
      setProjects(res?.data);
    } else {
      setProjects([])
    }
  };

  const breadcrumbItems = [
    {
      href: "/",
      title: (
        <span className="flex gap-2 items-center">
          <HomeIcon className="h-6 w-6 text-gray-500" />
          <span className="text-gray-400 sm:text-lg">Home</span>
        </span>
      ),
    },
    {
      href: "#",
      title: (
        <span className="flex gap-2 items-center">
          <DocumentChartBarIcon className="h-6 w-6 text-gray-300" />
          <span className="text-gray-400 sm:text-lg">Task Overview</span>
        </span>
      ),
    },
  ];


  const getTaskOverview = async () => {
    try {
      setLoading(true);
      const res = await getRequest("getTaskOverview");
      // console.log(res)
      if (res?.success) {
        setTaskOverview(res.data)
      }

    } catch (error) {
      console.log(error)
      setTaskOverview([])
    } finally {
      setLoading(false);
    }
  };

  const groupData = {}
  taskOverview.forEach((row) => {
    const name = row?.EMPLOYEE_NAME
    if (!groupData[name]) {
      groupData[name] = {
        ...row,
        name: name,
        department: row.DEPARTMENT_TITLE,
        image: row.IMAGE,

        task: []
      }
    }
    groupData[name].task.push({
      lastTaskName: row.CLIENTTITLE,
      projectName: row.PROJECTTITLE,
      assignDate: row.ASSIGNDATE,
      taskID: row.ID,
      dueDate: row.DUEDATE,
      status: row.STATUS
    })
  })
  const taskOverviewData = Object.values(groupData)
  // console.log(taskOverviewData)
  useEffect(() => {
    getTaskOverview()
    getAllProjects();
  }, [])

  return (
    <div className="p-4 md:p-6 lg:p-8">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between">
        <span className="flex flex-wrap gap-4 justify-between items-start md:items-center w-full">
          <span className="flex flex-col gap-2 text-xl md:text-4xl font-black w-full md:w-auto">
            Task Overview
            <Breadcrumb items={breadcrumbItems} />
          </span>
        </span>
        <div className="flex gap-2 mt-4 md:mt-0">
          <Button
            className="bg-green-400 font-bold lg:text-xl text-black py-6 px-4"
            variant="filled"
            icon={<PlusOutlined />}
            onClick={showModal}
          >
            Add Task
          </Button>
        </div>
      </div>

      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4  flex-grow-0  gap-3'>
        {/* {console.log(taskOverviewData)} */}
        {loading ? (
          // Show 4 loader cards
          [...Array(8)].map((_, i) => <TaskCardSkeleton key={i} />)
        ) : (
          !loading && taskOverviewData.map((emp, i) => (
            <ProfileTaskCard
              key={i}
              details={taskOverview}
              profileSrc={emp?.image}
              name={emp?.name}
              department={emp?.department}
              tasks={emp?.task}
            />
          ))
        )}
        {!loading && taskOverviewData?.length === 0 && (
          <div className="col-span-full flex flex-col items-center justify-center py-20 text-gray-500">
            <p className="text-2xl animate-pulse font-semibold">No Tasks found</p>
            <p className="text-sm">No Tasks available </p>
          </div>
        )}
      </div>
      <TaskModal
        isModalOpen={isModalOpen}
        handleOk={handleOk}
        handleCancel={handleCancel}
        selectedTask={selectedTask}
        setProjects={setProjects}
        projects={projects}
        setTableReFetchData={setTableReFetchData}
      />
    </div>
  )
}

export default TaskOverview